module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.complete),
      expression: "!complete"
    }]
  }, [_c('div', {
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('commonFormRender', {
    ref: "form",
    attrs: {
      "form": _vm.form,
      "formField": _vm.formField,
      "isReadonly": _vm.isReadonly,
      "complete": _vm.complete,
      "modelId": _vm.modelId,
      "groupList": _vm.groupList,
      "otherChange": _vm.otherChange,
      "selectChange": _vm.selectChange,
      "queryForignData": _vm.queryForignData
    }
  }, [_c('div', {
    staticClass: "m-t-20 m-b-20"
  }, [(!_vm.typeDetail) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _vm._v(" "), (_vm.level != 20) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(!_vm.isDialog) ? _c('el-button', {
    staticClass: "m-l-30",
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]) : _c('el-button', {
    staticClass: "m-l-30",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("返回")]), _vm._v(" ")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cb0fb6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/formRender.vue
// module id = 1940
// module chunks = 2